<template>
  <div class="lv-info-option">
    <div
      v-for="(option, optionIndex) in value"
      :key="optionIndex"
      class="mb-1"
    >
      <div class="d-flex">
        <p class="font-weight-bold mb-0">{{option.name}}</p>
        <p v-if="!option.has_child" class="mb-0">{{`： ${$_setText(option)}`}}</p>
      </div>
      <div v-if="option.has_child" class="lv-info-option__subOption pl-2">
        <div
          v-for="(subOption, subOptionIndex) in option.answer_setting_items"
          :key="subOptionIndex"
          class="d-flex"
        >
          <p class="font-weight-bold mb-0">{{subOption.name}}</p>
          <p class="mb-0">{{`： ${$_setText(subOption)}`}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import H_optionItem from '@/helpers/optionItem';

export default {
  props: {
    value: {
      type: Array,
    }
  },
  methods: {
    $_setText(rawData) {
      return H_optionItem.setDisplayText(rawData);
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/lv-info-option.scss";
</style>